import moment from 'moment'
import { useQuery } from 'react-query'
import { ProblemDetails } from '../errors'
import {
    getArrivalTime,
    getFreeServiseTimes,
    getPublicHolidays,
    getStartProtectionDays,
} from './services'
import { StartProtectionDay, ArrivalTime, FreeServiseTimes } from './types'

export const QUERYKEY_ARRIVALTIME = 'arrivalTime'
export function useArrivalTimeQuery(lat: any, lng: any) {
    return useQuery<ArrivalTime, ProblemDetails>(
        [QUERYKEY_ARRIVALTIME, lat, lng],
        () => getArrivalTime(lat, lng),
        {
            enabled: lat !== undefined && lng !== undefined,
        },
    )
}
export const QUERYKEY_FREESERVISETIMES = 'FreeServiseTimes'
export function useFreeServiseTimesQuery(
    carID?: string,
    synonym?: string,
    date?: Date,
) {
    return useQuery<FreeServiseTimes, ProblemDetails>(
        [QUERYKEY_FREESERVISETIMES, carID, synonym, date],
        () => getFreeServiseTimes(carID, synonym, date),
        {
            enabled:
                carID !== undefined &&
                synonym !== undefined &&
                date !== undefined &&
                moment(date).isValid(),
            retry: false,
        },
    )
}

export const QUERYKEY_STARTPROTECTIONDAYS = 'StartProtectionDays'
export function useStartProtectionDays() {
    return useQuery<StartProtectionDay[], ProblemDetails>(
        QUERYKEY_STARTPROTECTIONDAYS,
        () => getStartProtectionDays(),
    )
}

export const useHolidaysQuery = () => {
    const currentYear = moment().year().toString()
    const holidaysQuery = useQuery<string[], ProblemDetails>(
        ['publicHolidays', currentYear],
        () => getPublicHolidays(currentYear),
        {
            enabled: !!currentYear,
        },
    )

    return holidaysQuery
}
